<template>
  <v-container fluid>
    <div class="div-100">
      <v-row no-gutters>
        <v-col cols="12" lg="9" md="8" ref="stream">
          <v-responsive :aspect-ratio="16 / 9">
            <router-view></router-view>
          </v-responsive>
        </v-col>

        <v-col
          cols="12"
          lg="3"
          md="4"
          order="3"
          order-lg="2"
          order-md="2"
          :class="$vuetify.breakpoint.smAndDown == true ? 'pt-2 px-0' : 'pl-2'"
        >
          <component v-bind:is="getTabs[0].typ" />
        </v-col>

        <v-col order="2" order-md="2" order-lg="2" cols="12">
          <v-container>
            <Info class="mt-3"/>
          </v-container>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
/*eslint-disable vue/no-unused-components*/
import VimeoFrame from "@/components/IFrameServices/VimeoFrame";
import SlidoFrame from "@/components/IFrameServices/SlidoFrame";
import Info from "../components/Info";

import { mapGetters } from "vuex";

export default {
  components: {
    SlidoFrame,
    VimeoFrame,
    Info,
  },
  created() {
    this.$router.replace({
      name: "Stream",
    });
  },
  computed: {
    getTabs() {
      if (!this.$vuetify.breakpoint.mobile)
        return this.tabs.filter((s) => s.id !== "info");
      else return this.tabs;
    },
    ...mapGetters("notification", ["roomState"]),
  },
  watch: {
    roomState: {
      handler(value) {
        if (value != "live") {
          this.$router.push({
            name: "Event",
            params: { eventId: this.$store.state.event.event_id },
          });
        }
      },
    },
  },

  data: () => ({
    tabs: [
      // { href: "#info", name: "Info", id: "info", typ: "Info" },
      { href: "#slido", name: "Slido", id: "slido", typ: "SlidoFrame" },
    ],
  }),
};
</script>

<style lang="scss">
.activeTab {
  font-family: Bold;
  font-weight: 100;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .event-info {
    font-size: 16px;
  }
}
</style>

<style lang="scss">
</style>